import React, { useState } from 'react';
import styles from '../deeborah_martinns/procedimentos_deeborah_martinns.module.scss';

// Importando imagens dos Iluminados
import i1 from './src/Iluminados/1.png';
import i2 from './src/Iluminados/2.png';
import i3 from './src/Iluminados/3.png';
import i4 from './src/Iluminados/4.png';
import i5 from './src/Iluminados/5.png';
import i6 from './src/Iluminados/6.png';
import i7 from './src/Iluminados/7.png';
import i8 from './src/Iluminados/8.png';
import i9 from './src/Iluminados/9.png';
import i10 from './src/Iluminados/10.png';
import i11 from './src/Iluminados/11.png';
import i12 from './src/Iluminados/12.png';
import i13 from './src/Iluminados/13.png';
import i14 from './src/Iluminados/14.png';

// Importando imagens dos Loiros
import l from './src/Loiros/1.png';
import l2 from './src/Loiros/2.png';
import l3 from './src/Loiros/3.png';
import l4 from './src/Loiros/4.png';
import l5 from './src/Loiros/5.png';
import l6 from './src/Loiros/6.png';
import l7 from './src/Loiros/7.png';
import l8 from './src/Loiros/8.png';
import l9 from './src/Loiros/9.png';
import l10 from './src/Loiros/10.png';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const imagensIluminados = [i1, i2, i3, i4, i5, i6, i7, i8, i9, i10, i11, i12, i13, i14];
const imagensLoiros = [l, l2, l3, l4, l5, l6, l7, l8, l9, l10];

const Procedimentos_deeborah_martinns: React.FC = () => {
    const [categoria, setCategoria] = useState<'Iluminados' | 'Loiros'>('Iluminados');

    const imagens = categoria === 'Iluminados' ? imagensIluminados : imagensLoiros;

    return (
        <div className={styles.procedimentos_deeborah_martinns}>
            <div className={styles.header}>
                <Link to="/deeborah_martinns" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1>Procedimentos</h1>
            </div>
            <div className={styles.botoes}>
                <button
                    className={categoria === 'Iluminados' ? styles.ativo : ''}
                    onClick={() => setCategoria('Iluminados')}
                >
                    Iluminados
                </button>
                <button
                    className={categoria === 'Loiros' ? styles.ativo : ''}
                    onClick={() => setCategoria('Loiros')}
                >
                    Loiros
                </button>
            </div>

            <div className={styles.galeria}>
                {imagens.map((src, i) => (
                    <img key={i} src={src} alt={`${categoria} ${i + 1}`} />
                ))}
            </div>
        </div>
    );
};

export default Procedimentos_deeborah_martinns;
